module.exports = __webpack_public_path__ + "img/02-CoursFrancais.02b59bf5.jpeg";